module.exports = __webpack_public_path__ + "img/greentick.f426cf97.svg";